// Regenerate breakpoint CSS tokens by running "yarn workspace @shopify/editor-core build:assets"

// Exporting as const means it will be typed as a Tuple instead of string[]
const editorBreakpointsAliases = ['mobileCommon', 'phablet', 'tablet', 'desktop', 'widescreen'];

// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style

const breakpoints = {
  phablet: '667px',
  tablet: '860px',
  desktop: '1080px',
  widescreen: '1614px',
  // Candidates for removal
  mobileCommon: '480px'
};

export { breakpoints, editorBreakpointsAliases };
